import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Zap } from "lucide-react";
import { typeformLinkProps } from "./TypeformModal";

const FinalCTA = () => {
    return (
        <section data-testid="final-cta-section" className="relative overflow-hidden py-32 sm:py-40">
            <div className="bg-grid-fade absolute inset-0" />
            <div className="absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-neon-purple/15 blur-[120px]" />
            <div className="absolute left-1/3 top-1/3 h-[260px] w-[260px] rounded-full bg-neon-pink/10 blur-[100px]" />

            <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
                <motion.h2
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="font-display text-4xl font-black leading-tight text-white sm:text-6xl"
                >
                    Ready to <span className="text-gradient-neon">GO VIRAL?</span>
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg"
                >
                    See exactly how Fan Creator will accelerate your growth. Book a free demo and discover
                    the strategies that top creators use to build massive, engaged audiences.
                </motion.p>
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.3 }}
                >
                    <a
                        {...typeformLinkProps}
                        data-testid="final-cta-button"
                        className="group mt-10 inline-flex items-center gap-2.5 rounded-full bg-gradient-to-r from-neon-purple via-neon-pink to-neon-blue px-9 py-4 text-base font-bold text-white transition-transform duration-200 hover:scale-105 glow-pink"
                    >
                        Request a Free Demo
                        <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
                    </a>
                    <p className="mt-6 font-mono-tech text-[11px] uppercase tracking-[0.25em] text-white/50">
                        No credit card required · 100% free · Learn how to scale fast
                    </p>
                </motion.div>
            </div>

            <footer className="relative mt-28 border-t border-border">
                <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-5 py-8 sm:flex-row sm:px-8">
                    <span className="flex items-center gap-2 font-display text-xs font-bold tracking-widest text-white/70">
                        <Zap size={14} className="text-neon-pink" />
                        FAN CREATOR · BY CLIENTSCLICK
                    </span>
                    <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/30">
                        You create. We scale.
                    </p>
                </div>
            </footer>
        </section>
    );
};

export default FinalCTA;
